import { ChevronRight } from "lucide-react";
import { DateTime } from "luxon";
import { UserAvatar } from "@/components/ui/stacked-avatars";
import { cn } from "@/lib/utils";
import type { ShareableEntity } from "@/lib/api/shareable-entities";
import { Scribbles } from "@somethings-ui/core/assets";

interface DeepThoughtsHubCardProps {
  entity: ShareableEntity;
  isNew: boolean;
  onClick?: () => void;
  className?: string;
}

export function DeepThoughtsHubCard({
  entity,
  isNew,
  onClick,
  className,
}: DeepThoughtsHubCardProps) {
  const completedAt = entity.activity?.completedAt ?? entity.created_at;
  const formattedDate = DateTime.fromJSDate(new Date(completedAt)).toFormat(
    "EEE, h:mm a",
  );

  const creatorName = entity.owner.name;
  const creatorAvatarUrl = entity.owner.profile_picture_url ?? undefined;

  return (
    <div
      onClick={onClick}
      className={cn(
        "flex cursor-pointer items-center gap-4 rounded-lg p-3 transition-colors hover:bg-gray-50",
        className,
      )}
    >
      <div className="relative h-20 w-16 shrink-0">
        <div className="absolute inset-0 -rotate-[5deg] overflow-hidden rounded-md bg-brand-darkMaroon shadow-md">
          <img
            src={Scribbles.orangeCloud}
            alt=""
            aria-hidden
            className="pointer-events-none absolute inset-0 h-full w-full scale-[1.6] object-cover"
          />
        </div>
        <div className="absolute -bottom-1 -right-1 z-10">
          <UserAvatar
            imageUrl={creatorAvatarUrl}
            name={creatorName}
            size={28}
            showBorder
          />
        </div>
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="font-bold text-primary">Deep Thoughts</span>
          <span className="h-1 w-1 rounded-full bg-text-tertiary" />
          <span className="text-sm text-text-tertiary">{formattedDate}</span>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        {isNew && <span className="h-2 w-2 rounded-full bg-purple-600" />}
        <ChevronRight className="h-5 w-5 text-gray-400" />
      </div>
    </div>
  );
}
